import * as actionTypes from './actionTypes';

const initialState = {
    token: localStorage.getItem("express_web_tk"),
    nombre: '',
    imagen_url: '',
    usuarioLoguedo: false
};

export default function (state = initialState, action) {

    switch (action.type) {
        case actionTypes.SET_USER_INFO:
            localStorage.setItem("express_web_tk", action.payload.token);
            return {
                ...state,
                ...action.payload
            };
        case actionTypes.SET_USER_LOGGED_IN:
            let token = state.token;
            if(!action.payload) {
                localStorage.setItem("express_web_tk", "");
                token = '';
            }
            return {
                ...state,
                token,
                usuarioLoguedo: action.payload
            };
        default:
            return state;
    }
}